import { render, staticRenderFns } from "./k-link.vue?vue&type=template&id=8be9a118"
import script from "./k-link.vue?vue&type=script&lang=js"
export * from "./k-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports